import { AxiosInstance } from 'axios';
import EmployeeBirthdaysRepositoryInterface, {
  EmployeeBirthdaysInterface,
} from '@/services/Calendar/EmployeeBirthdays/Interfaces';

export default class EmployeeBirthdaysRepository implements EmployeeBirthdaysRepositoryInterface {
  private apiPrefix = '/event-calendar/employee-birthday';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllBirthdays(): Promise<EmployeeBirthdaysInterface[]> {
    const res = await this.axios.get(this.apiPrefix);

    return res.data;
  }

  public async getBirthdaysForMonth(month: number): Promise<EmployeeBirthdaysInterface[]> {
    const res = await this.axios
      .get(`${this.apiPrefix}/month/${month}`);

    return res.data;
  }
}
